export enum Step {
  START = 'Start',
  CHOOSE_GOOGLE_ADS_ACCOUNT = 'Choose Google Ads Account',
  FILL_YOUR_INFO = 'Fill Your Info',
  FILL_BUSINESS_INFO = 'Fill Business Info'
}
